import createIcon from '../../createIcon';

/**
 * @component @name Rocket
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgMi4yNUMxMiAyLjI1IDE2LjUgNC4yOSAxNi41IDEyLjc1QzE2LjUgMTUuMjQgMTUuNDYgMTguMzIgMTQuOSAxOS43NUg5LjFDOC41NCAxOC4zMiA3LjUgMTUuMjQgNy41IDEyLjc1QzcuNSA0LjI5IDEyIDIuMjUgMTIgMi4yNVpNMTQgMTAuNzVDMTQgOS42NSAxMy4xIDguNzUgMTIgOC43NUMxMC45IDguNzUgMTAgOS42NSAxMCAxMC43NUMxMCAxMS44NSAxMC45IDEyLjc1IDEyIDEyLjc1QzEzLjEgMTIuNzUgMTQgMTEuODUgMTQgMTAuNzVaTTcuNjkgMjAuMjdDNy4yMSAxOS4wNCA2LjE3IDE2LjEgNi4wMiAxMy40TDQuODkgMTQuMTVDNC4zMyAxNC41MyA0IDE1LjE1IDQgMTUuODJWMjEuNzVMNy42OSAyMC4yN1pNMjAgMjEuNzVWMTUuODJDMjAgMTUuMTUgMTkuNjcgMTQuNTMgMTkuMTEgMTQuMTZMMTcuOTggMTMuNDFDMTcuODMgMTYuMSAxNi43OCAxOS4wNSAxNi4zMSAyMC4yOEwyMCAyMS43NVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Rocket = createIcon('Rocket', [
  [
    'path',
    {
      d: 'M12 2.25C12 2.25 16.5 4.29 16.5 12.75C16.5 15.24 15.46 18.32 14.9 19.75H9.1C8.54 18.32 7.5 15.24 7.5 12.75C7.5 4.29 12 2.25 12 2.25ZM14 10.75C14 9.65 13.1 8.75 12 8.75C10.9 8.75 10 9.65 10 10.75C10 11.85 10.9 12.75 12 12.75C13.1 12.75 14 11.85 14 10.75ZM7.69 20.27C7.21 19.04 6.17 16.1 6.02 13.4L4.89 14.15C4.33 14.53 4 15.15 4 15.82V21.75L7.69 20.27ZM20 21.75V15.82C20 15.15 19.67 14.53 19.11 14.16L17.98 13.41C17.83 16.1 16.78 19.05 16.31 20.28L20 21.75Z',
      key: 'vbya85',
    },
  ],
]);

export default Rocket;
